import Vue from 'vue'
import Router from 'vue-router'
import { constantRouterMap } from '@/config/router.config'
import store from '@/store'

Vue.use(Router)

// s 解决 Vue 重复点击相同路由，出现 Uncaught (in promise) NavigationDuplicated: Avoided redundant navigation 问题
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}
// e 解决 Vue 重复点击相同路由

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

router.beforeEach((to, from, next) => {
  if (to.query.access_token) {
    store.dispatch('Loginbytoken', { access_token: to.query.access_token }).then(res => {
      // if (res.data.code === 200) {
      //   // 登陆已完成进入路由
      //   next()
      // }
      // 登陆已完成进入路由
      next()
    })
  } else { // 常规登陆
    // if (to.meta.title) { // 路由变化修改title
    //   document.title = to.meta.title
    // }
    next()
  }
})

export default router
